import React from "react";
import styles from "./Quote.module.css";
import {Container, Column, Row} from "../grid";

type Props = {
    quote: string;
};

export default function Quote(props: Props) {
    return (
        <div className={styles.topDiv}>
            <Container>
                <Row>
                    <Column large={12} medium={8}>
                        <div className={styles.quote}>{props.quote}</div>
                    </Column>
                </Row>
            </Container>
        </div>
    );
}
